import { render, staticRenderFns } from "./SlideDiscount.vue?vue&type=template&id=992baf52&scoped=true"
import script from "./SlideDiscount.vue?vue&type=script&lang=js"
export * from "./SlideDiscount.vue?vue&type=script&lang=js"
import style0 from "./SlideDiscount.vue?vue&type=style&index=0&id=992baf52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992baf52",
  null
  
)

export default component.exports